import { useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "react-query";

import { DELETE, GET } from "../../../api/requests";

export function useScheduledWorkflowVariant(workflowId, scheduledWorkflowId) {
  const navigate = useNavigate();
  // get the workflow data
  const { data: workflowData, isLoading: isWorkflowLoading } = useQuery(
    ["workflow", workflowId],
    async () => {
      const response = await GET(`/workflow/${workflowId}`);
      return response.workflow;
    }
  );

  // get the data for this scheduled workflow variant
  const { data: variantData, isLoading: isVariantDataLoading } = useQuery(
    ["scheduledVariant", workflowId, scheduledWorkflowId],
    async () => {
      return await GET(
        `/workflows/${workflowId}/scheduled/${scheduledWorkflowId}`
      );
    }
  );

  // get all of the runs for this scheduled workflow variant
  const { data: scheduledRunsData, isLoading: isScheduledRunsLoading } =
    useQuery(
      ["runs", workflowId, scheduledWorkflowId],
      async () => {
        return await GET(
          `/workflows/${workflowId}/scheduled/${scheduledWorkflowId}/runs`
        );
      },
      {
        enabled: variantData !== null,
      }
    );

  // delete a scheduled workflow variant
  const { mutate: deleteScheduledVariant } = useMutation(
    async (id) => {
      return await DELETE(
        `/workflows/${workflowId}/scheduled/${scheduledWorkflowId}`
      );
    },
    {
      onSuccess: () => {
        navigate(-1);
      },
      onError: (error) => {
        console.error(error);
      },
    }
  );

  return {
    workflowData,
    isWorkflowLoading,
    variantData,
    isVariantDataLoading,
    scheduledRunsData,
    isScheduledRunsLoading,
    deleteScheduledVariant,
  };
}
